import React from "react";
import { motion } from "framer-motion";

const LevelsPagination = ({ activeGrade, onLevelChange }) => {
  const grades = [10, 9, 8, 7, 6, 5, 4, 3, 2, 1];

  return (
    <div className="flex flex-col items-center bg-white/40 backdrop-blur-md rounded-2xl p-1.5 shadow-sm border border-white/20 h-full self-start mt-2">
      <div className="mb-2 bg-blue-600 rounded px-2 py-0.5 shadow-sm shadow-blue-100">
        <span className="text-[9px] font-black uppercase tracking-widest text-white">
          levels
        </span>
      </div>
      
      <div className="flex flex-col gap-1">
        {grades.map((grade) => {
          const isActive = String(activeGrade) === String(grade);
          
          return (
            <motion.button
              key={grade}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => onLevelChange(grade)}
              className={`w-8 h-8 rounded-xl flex items-center justify-center font-bold text-xs transition-all duration-300 ${
                isActive
                  ? "bg-blue-600 text-white shadow-md shadow-blue-200"
                  : "bg-white text-slate-600 hover:bg-slate-50 border border-slate-50"
              }`}
            >
              {grade}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default LevelsPagination;
